module.exports = __webpack_public_path__ + "img/insights-dualtone.3395798b.svg";